<template>
    <div class="news-card">
        <a :href="result.detailPage" class="news-card__image">
            <img v-if="result.detailPicture" :src="result.detailPicture.src" :alt="result.detailPicture.alt" >
            <img v-else-if="result.picture" :src="result.picture.src" :alt="result.picture.alt">
        </a>
        <div class="news-card__header">
            <span v-if="result.date" class="news-card__date">{{result.date}}</span>
            <a v-if="result.name" :href="result.detailPage" class="def-title-3">{{result.name}}</a>
        </div>
        <a :href="result.detailPage" v-if="result.previewText" class="news-card__text">{{result.previewText}}</a>
        <a v-if="result.detailPage && messages.btnDetail && getScreenWidth() >= 992"
           :href="result.detailPage" class="def-link">{{messages.btnDetail}}</a>
    </div>
</template>

<script>
    export default {
        name: 'news-card',
        selector: '.news-card',
        props: {
            result: {
                type: Object,
                default: () => ({
                    "id": 57867,
                    "name": "Porro voluptatum et quae quo non id ea eligendi.",
                    "detailPage": "/news/porro-voluptatum-et-quae-quo-non-id-ea-eligendi/",
                    "previewText": "Ullam animi voluptas quam ullam totam sunt doloremque. Est repudiandae numquam officiis repellendus unde. In dolor repellat possimus placeat. Velit rerum labore nam labore laudantium enim aut. Laboriosam nemo qui a explicabo ut minus. Molestiae adipisci culpa est temporibus reiciendis ut. Consectetur ut omnis architecto sit ducimus excepturi mollitia. Dolorem autem deleniti eius sed id expedita aut mollitia.",
                    "article": 57867,
                    "picture": {
                        "alt": "Porro voluptatum et quae quo non id ea eligendi.",
                        "src": "/upload/resize_cache/iblock/1ea/200_200_140cd750bba9870f18aada2478b24840a/1ea07814cd003707553e1c75ce758e78.jpeg"
                    },
                    "detailPicture": {
                        "alt": "Sit possimus eos doloremque qui.",
                        "src": "/local/templates/love-you/images/front-end/news.png"
                    },
                    "attributes": {
                        "id": "bx_3966226736_57867"
                    },
                    "date": "10/26/2020 02:12:03 am"
                })
            },
            messages: {
                type: Object,
                default: () => ({
                    "title": "Новини",
                    "btnDetail": "Читати детальніше"
                })
            }
        },
        methods: {
            getScreenWidth() {
                return window.innerWidth;
            }
        }
    }
</script>

<style lang="scss">
    .news-card{
        background-color: #fff;
        padding: 16px;
        display: grid;
        @include point-md{
            grid-template-columns: repeat(3, 1fr);
            grid-column-gap: 24px;
            padding: 24px;
            & > *:not(.news-card__image){
                margin-left: 0;
                margin-right: 0;
            }
        }
        @include point-lg{
            padding: 0 0 32px;
            grid-template-columns: repeat(1, 1fr);
            & > *:not(.news-card__image){
                margin-left: 32px;
                margin-right: 32px;
            }
        }

        &__image{
            display: block;
            align-self: center;
            margin-bottom: 24px;
            @include point-md{
                margin-bottom: 0;
            }
            @include point-lg{
                margin-bottom: 32px;
            }
            img{
                display: block;
                max-width: 100%;
                max-height: 380px;
                margin: 0 auto;
            }
        }
        &__date{
            font-size: rem(14);
            line-height: 100%;
            color: #757575;
            margin-bottom: 24px;
            order: 2;
            @include point-md{
                margin-bottom: 0;
                margin-top: auto;
            }
            @include point-lg{
                margin-bottom: 8px;
                order: 1;
            }
        }
        &__text{
            font-size: rem(16);
            line-height: 120%;
            color: #363636;
            text-overflow: ellipsis;
            overflow: hidden;
            max-height: 96px;
            @include point-lg{
                font-size: rem(18);
                margin-bottom: 32px;
                max-height: 40px;
            }
        }
        &__header{
            display: flex;
            flex-direction: column;
        }
        .def-link{
            font-weight: 500;
            font-size: rem(12);
            letter-spacing: 0.1em;
            text-transform: uppercase;
            color: var(--text-colour-secondary);
            margin-top: auto;
        }
        .def-title-3{
            margin-bottom: 16px;
            order: 1;
            @include point-lg{
                order: 2;
            }
        }
    }
</style>